/**
 * Google Analytics 4 — loaded without inline scripts so a strict CSP
 * (no script-src 'unsafe-inline') can still allow gtag.js from Google.
 */
const GA_MEASUREMENT_ID = 'G-5J670LJZ6H';

window.dataLayer = window.dataLayer || [];
function gtag() {
    window.dataLayer.push(arguments);
}
window.gtag = gtag;
gtag('js', new Date());
gtag('config', GA_MEASUREMENT_ID);

const script = document.createElement('script');
script.async = true;
script.src = `https://www.googletagmanager.com/gtag/js?id=${GA_MEASUREMENT_ID}`;
document.head.appendChild(script);
